import { render, staticRenderFns } from "./qkksList.vue?vue&type=template&id=dbdca208&"
import script from "./qkksList.vue?vue&type=script&lang=js&"
export * from "./qkksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports